import React, { Component } from "react";

class Ambassadrice extends Component {
  state = {};
  render() {
    return (
      <li className="list-detail">
        <a
          onClick={() => this.props.showContent(this.props.ambassadrice.id)}
          onMouseEnter={
            true
              ? () => this.props.handleMouseEnter(this.props.ambassadrice.id)
              : null
          }
          onMouseLeave={this.props.handleMouseLeave}
          //href="#"
        >
          <img
            className="membre_photo"
            src={this.props.ambassadrice.acf.ambassadrice_photo}
            alt=""
          />
          <div className="list-text">
            <p className="list-titre">{this.props.ambassadrice.name}</p>
            <p className="list-localisation">
              {this.props.ambassadrice.acf.ambassadrice_ville}
            </p>
          </div>
        </a>
      </li>
    );
  }
}

export default Ambassadrice;



// WEBPACK FOOTER //
// ./src/Components/Ambassadrice.jsx